import React from 'react';
import cn from 'classnames';

import Paginator from 'paginator';
import Link from 'gatsby-link';

import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import times from 'lodash/times';

import { withStyles } from '@material-ui/core/styles';

import PreviousIcon from './assets/previous.svg';
import NextIcon from './assets/next.svg';

const styles = () => ({
  root: {},
  link: {
    color: '#b8b8b8',
    textDecoration: 'none',
    fontFamily: 'Raleway',
    fontSize: 20,
    lineHeight: 1.34,
    fontWeight: 'normal',
  },
  activeLink: {
    color: '#6a27e8',
    fontWeight: 'bold',
  },
  iconBtn: {
    margin: '0 12px',
  },
  icon: {
    height: 21.3,
    width: 11.7,
    objectFit: 'contain',
  },
  pageBtn: {
    margin: '0 6px',
  },
  disabledLink: {
    display: 'none',
  },
});

const Pagination = ({
  classes,
  className,
  index,
  first,
  last,
  pageCount,
  category,
  author,
}) => {
  const pagination = new Paginator(10, 10);
  const paginationInfo = pagination.build(10 * pageCount, index);
  const { first_page: firstPage, last_page: lastPage } = paginationInfo;
  const items = times(lastPage - firstPage + 1, i => i + firstPage);

  let previousUrl = (index - 1).toString();
  const nextUrl = (index + 1).toString();

  if (previousUrl === '1') {
    previousUrl = '';
  }

  let urlPrefix = '/blog/';
  urlPrefix = !isEmpty(category)
    ? `${urlPrefix}category/${category.slug}/`
    : urlPrefix;
  urlPrefix = !isEmpty(author)
    ? `${urlPrefix}author/${author.slug}/`
    : urlPrefix;

  if (items.length === 1) return null;

  return (
    <div className={cn(classes.root, className)}>
      <div>
        <Link
          to={urlPrefix + previousUrl}
          className={cn(classes.link, classes.iconBtn, {
            [classes.disabledLink]: first,
          })}
        >
          <img
            src={PreviousIcon}
            alt="previous-icon"
            className={classes.icon}
          />
        </Link>
      </div>
      <div>
        {map(items, item => (
          <Link
            key={item}
            to={`${urlPrefix}${item === 1 ? '' : item}`}
            className={cn(classes.link, classes.pageBtn, {
              [classes.activeLink]: item === index,
            })}
          >
            <span>{item}</span>
          </Link>
        ))}
      </div>
      <div>
        <Link
          to={urlPrefix + nextUrl}
          className={cn(classes.link, classes.iconBtn, {
            [classes.disabledLink]: last,
          })}
        >
          <img src={NextIcon} alt="next-icon" className={classes.icon} />
        </Link>
      </div>
    </div>
  );
};

export default withStyles(styles)(Pagination);
